import { LoginCard } from '@/components/layout/LoginCard';
import { Button, Form, FormInput, FormLabel, StandaloneLink } from '@/components/wm';
import { apiRequest } from '@/utils/request';
import * as React from 'react';
import { useEffect, useState } from 'react';

export function ForgotPassword({ loginEmail, onAlert, backToLogin }) {
    const
        [email, setEmail] = useState(loginEmail),
        [formFilled, setFormFilled] = useState(false),
        [loading, setLoading] = useState(false);

    useEffect(() => {
        setFormFilled(email !== '');
    }, [email]);

    const handleSubmit = async event => {
        event.preventDefault();
        setLoading(true);

        const data = {
            email
        };

        try {
            const response = await apiRequest('/reset_password', 'POST', data);

            if (response.status === 201) {
                onAlert(i18next.t('ui.passwords.reset_instructions'), 'success', i18next.t('common.success').capitalize());
            }
        } catch (err) {
            const errorMessage = err.response?.data?.error?.capitalize() || i18next.t('alert_boxes.error_occurred');

            onAlert(errorMessage, 'destructive', i18next.t('alert_boxes.failed'));
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 500);
        }
    };

    return (
        <LoginCard>
            <Form>
                <FormLabel htmlFor="email">{i18next.t('ui.passwords.email_to_reset')}</FormLabel>
                <FormInput
                    id="email"
                    onChange={e => setEmail(e.target.value)}
                    placeholder="m@example.com"
                    required
                    type="email"
                    value={email}
                />
                <Button className="tw-w-full" disabled={!formFilled} loading={loading} onClick={handleSubmit} type="submit" variant="secondary">
                    {i18next.t('ui.actions.reset_password')}
                </Button>
            </Form>
            <StandaloneLink icon="arrowLeftCircle" onAction={backToLogin} text={i18next.t('ui.passwords.back_to_login')}/>
        </LoginCard>
    );
}
